import * as React from 'react'
import { useTranslation } from 'react-i18next';
import {
    Checkbox,
    DefaultButton,
    Link,
    Modal,
    PrimaryButton,
    TextField
} from '@fluentui/react';
import * as Api from "../../../../api/src"
import ModalHeader from '../../../../control/modalHeader';
import { ToastAppMsgContext } from '../../../../context/toastApp.Context';
import ErrorMesage from '../../../../control/MessageBar/Error';
import { LoadingAppContext } from '../../../../context/loadingApp.context';
import { saveAs } from 'file-saver';
export interface ModaImportProductProps {
    IsOpen: boolean,
    onCloseModal: () => void;
}
const ProductsApi = new Api.ProductsApi();
const ModalImportProduct = ({ IsOpen, onCloseModal }: ModaImportProductProps) => {
    const [isShowModal, SetIsShowModal] = React.useState(false)
    const [detail, SetDetail] = React.useState<{ overrideIfDuplicated: boolean, formFiles: any }>({ overrideIfDuplicated: true, formFiles: null });
    const [dataResponse, SetDataResponse] = React.useState<Api.ImportExcelResponse>();
    const [forgotErrorMessage, SetForgotErrorMessage] = React.useState('');
    const { t } = useTranslation();
    const getTitle = (): string => {
        return t("ImportProducts");
    }
    const { setLoadingStatus, label } = React.useContext(LoadingAppContext);
    React.useEffect(() => {
        SetIsShowModal(IsOpen);
        let a = document.getElementById("uploadFile");
        if (a) {
            (a as any).value = "";
        }
        SetDetail({ formFiles: null, overrideIfDuplicated: true });
    }, [IsOpen]);
    const onClose = () => {
        onCloseModal()
        SetIsShowModal(false)
    }
    const onImport = async () => {
        if (!detail.formFiles) {
            return;
        }
        setLoadingStatus({ Ishow: true, Style: { backgroundColor: "#eeeeee69" } })
        let res = await ProductsApi.apiProductsImportProductPost(detail.overrideIfDuplicated, detail.formFiles as any);
        SetDataResponse(res.data)
        let a = document.getElementById("uploadFile");
        (a as any).value = "";
        setLoadingStatus({ Ishow: false, Style: { backgroundColor: "#eeeeee69" } })
    }
    const handleOnChange = (e: any) => {
        SetDataResponse(undefined);
        SetDetail({ ...detail, formFiles: e.target.files[0] });
    };
    return (
        <Modal
            isOpen={isShowModal}
            isModeless={true}
        >
            <ModalHeader title={getTitle()} onCloseModal={() => {
                onClose();
            }} />
            <div className={'modal-content'} style={{ width: 700 }}>
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row  ms-Grid-col margin-0 ms-md3">
                        <ErrorMesage Message={forgotErrorMessage} onClose={() => { SetForgotErrorMessage('') }} />
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
                            {t("ImportProductsFromAExcelFile")}
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-md12  ms-Grid-col padding-left-0 padding-right-0">
                            {t("IfYouDoNotHaveImportTemplateExcelFile")} <Link onClick={async () => {
                                let res = await ProductsApi.apiProductsExportTemplateProductPost({
                                    responseType: 'blob',
                                });
                                saveAs((res as any).data as Blob, `ImportProductTemplate.xlsx`);
                            }}>{t("ClickHereToDownload")}</Link>
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-md12 import-product  ms-Grid-col padding-left-0 padding-right-0" onClick={() => {
                            let a = document.getElementById("uploadFile");
                            if (a) {
                                a.click();
                            }
                        }}>
                            <input id="uploadFile" multiple accept={"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"} style={{ display: "none" }} type="file" onChange={handleOnChange} />
                            <div>
                                <div>{t("SelectFileYromYourComputer")}</div>
                                <div style={{ textAlign: 'left' }}>
                                    <div>
                                        {detail.formFiles?.name ? (t("FileSelected") + ": " + detail.formFiles?.name) : ""}
                                    </div>
                                    <div>
                                        {!!dataResponse && detail.formFiles?.name ? (t("ImportSuccess") + ": " + dataResponse?.TotalItemImportSuccess) : ""}
                                    </div>
                                    <div>
                                        {!!dataResponse && detail.formFiles?.name ? (t("ImportFail") + ": " + dataResponse?.TotalItemImportFail) : ""}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-md6 margin-0 padding-left-0 ms-Grid-col">
                            <Checkbox label={t("OverrideIfDuplicated")} checked={detail?.overrideIfDuplicated} onChange={(e, checked) => { SetDetail({ ...detail, overrideIfDuplicated: checked || false }); }}></Checkbox>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'modal-footer'}>
                <DefaultButton onClick={() => { onClose(); }} className={"margin-left-10"}>{t("Close")}</DefaultButton>
                <PrimaryButton className={"margin-left-10"} onClick={() => { onImport(); }}>{t("Import")}</PrimaryButton>
            </div>
        </Modal>
    );
}
export default ModalImportProduct;


